import { Pressable as NbPressable } from 'native-base';

import { addWithConfig } from '../../utils';

export const Pressable = NbPressable;

export default addWithConfig(Pressable);
